//公共数据

export default {
  state: {
    dateFormat:"yyyy-MM-DD HH:mm:ss",
    
    address: [],
    //资产分类
    leaseTypeOptions: [
      {id: 'SHOP', name: '商铺'},
      {id: 'HOME', name: '住宅'},
      {id: 'MARKET', name: '市场'},
      {id: 'FACTORY_BUILDING', name: '厂房'},
      {id: 'OFFICE', name: '办公'},
      {id: 'LAND', name: '土地'},
      {id: 'SITE', name: '场地'},
      {id: 'AGRICULTURAL_LAND', name: '农用地'},
      {id: 'BUSINESS', name: '商业'},
      {id: 'OTHER', name: '其他'},
    ],
    //出租物经营用途约定
    operatingTypeOptions: [
      {id: 'OFFICE', name: '办公'},
      {id: 'BUSINESS', name: '商业'},
      {id: 'INDUSTRY', name: '工业'},
      {id: 'RESIDE', name: '居住'},
      {id: 'WAREHOUSING', name: '仓储'},
      {id: 'OTHER', name: '其他'},
    ],//免租期
    freePeriodOptions: [
      {id: '1', name: '有'},
      {id: '0', name: '无'},
    ],
    //资产类别
    areaTypeOptions: [
      {id: 'STATE_OWNED_ASSETS', name: '区属国有资产'},
      {id: 'DISTRICT_COLLECTIVE_ASSETS', name: '区属集体资产'},
      {id: 'TOWNSHIP_OWNED_ASSETS', name: '镇属国有资产'},
      {id: 'TOWNSHIP_COLLECTIVE_ASSETS', name: '镇属集体资产'},
    ],
    //房产证
    deedFlagOptions: [
      {id: 0, name: '否'},
      {id: 1, name: '是'},
    ],
    //竞租方资格
    bidderQualificationOptions: [
      {id: 'NATURAL_PERSON', name: '自然人'},
      {id: 'LEGAL_PERSON', name: '法人'},
      {id: 'NATURAL_LEGAL_PERSON', name: '自然人或法人'},
    ],
    //竞租方资格
    preAuditMethodOptions: [
      {id: 'ONLINE_REVIEW', name: '线上审核'},
      {id: 'OFFLINE_REVIEW', name: '线下审核'},
    ],
    //租金支付约定
    paymentCycleOptions: [
      {id: 'MONTH', name: '月'},
      {id: 'QUARTER', name: '季'},
      {id: 'HALF_YEAR', name: '半年'},
      {id: 'YEAR', name: '年'},
    ],
    //资产类别
    lease_area_type: [{
      "name": "区属国有资产",
      "id": "STATE_OWNED_ASSETS"
    }, {
      "name": "区属集体资产",
      "id": "DISTRICT_COLLECTIVE_ASSETS"
    }, {
      "name": "镇属集体资产",
      "id": "TOWNSHIP_COLLECTIVE_ASSETS"
    }, {
      "name": "镇属国有资产",
      "id": "TOWNSHIP_OWNED_ASSETS"
    }, {
      "name": "国有资产",
      "id": "STATE_ASSETS"
    }, {
      "name": "村属集体资产",
      "id": "VILLAGE_OWNED_ASSETS"
    }, {
      "name": "企业资产",
      "id": "COMPANY_ASSETS"
    }, {
      "name": "个人资产",
      "id": "PERSON_ASSETS"
    }, {
      "name": "其他",
      "id": "OTHER_ASSETS"
    }],
    expectedModeOptions: [
      {id: "ENGLISH", name: "增价拍 (延时周期：5分/次)"},
      {id: "DUTCH", name: "减价拍"},
      {id: "SEALED", name: "一口价暗标"},
      {id: "PUBLIC", name: "一口价明标"},
    ],
    unitOptions: [
      {id: 1, name: "元/年"},
      {id: 2, name: "元/平米/日"},
    ],


  },
  mutations: {
    SET_ADDRESS(state, address) {
      state.address = address
    },
  },
  actions: {
    getAddress({commit},address){
      commit('SET_ADDRESS',address)
    },
  },
}
